import React from "react"; 

// core components
import GridItem from "./../../views/Grid/GridItem.js";
import GridContainer from "./../../views/Grid/GridContainer.js";
import Table from "./../../views/Table/Table.js";
import Card from "./../../views/Card/Card.js";
import CardHeader from "./../../views/Card/CardHeader.js";
import CardBody from "./../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfManuPlant from './confMPlant/ConfManuPlant'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded'; 
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Warehouses = (props) => { 
  const [data,setData] = React.useState(false)
  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activePlant,setActivePlant] = React.useState(false)
  
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [selectValue,setSelectValue] = React.useState("ALL")

  React.useEffect(() => {
    fetchOrder()
  },[]);


  React.useEffect(() => {
    if(data) {
      let arr = [];
      arr = data.filter(val => {
        if( val.name.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.location.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.address.toLowerCase().includes(searchValue.toLowerCase())
          ) {
          return val;
        }
      })
      arr = arr.filter(val => {
        if(val.location == selectValue || selectValue == "ALL") {
          return val;
        }
      })
      setFilteredData(arr);
    }
  },[searchValue,selectValue])


  const fetchOrder = () => {
    setData(false);
    axios({
      method: "post",
      url: "/getAllManufacturingPlant", 
    }).then(res => {
      setData(res.data.data)  
      setFilteredData(res.data.data)
    }).catch(err => {
      console.log(err)
    });
  }

  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteManufacturingPlant",
      data: {
        plantId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      fetchOrder();
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  
  
  // FILTER data
  let locations = ["ALL"];
  data && data.forEach(val => locations.push(val.location));
  locations = [...new Set(locations)]

  const details = [];
  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.name,
        val.location,
        val.contactNum,
        val.address, 
        val.status,
        <React.Fragment>  
          <IconButton onClick={() => {
            setActivePlant(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>

          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}>
            <IconButton >
              <DeleteRoundedIcon />
            </IconButton>
            </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfManuPlant
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          fetchOrder()
        }}
        setAlert={(msg) => setAlert(msg)}
      />}

      {activePlant && <ConfManuPlant 
        type="EDIT"
        plant={activePlant} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setActivePlant(false)
          fetchOrder()
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 

      <Snackbar open={alert} handleClose={() => setAlert(false)}/>

      
      <TopBar
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)} 

        select={true}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Locations"
        options={locations}
        values={locations}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Manufacturing Plant</h4> 
              <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Plant</Button>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No", "Name", "Location", "Contact Number", "Address","Status","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

export default withRouter(Warehouses);